import { Link, useParams } from "react-router-dom";
import SiteLayout from "@/components/layout/SiteLayout";
import Seo from "@/components/feature/Seo";
import DetailContent from "@/pages/detail/components/DetailContent";
import { getMediaById, typeLabel } from "@/mocks/media";

export default function Detail() {
  const { id } = useParams();
  const media = id ? getMediaById(id) : undefined;

  if (!media) {
    return (
      <SiteLayout active="">
        <Seo
          title="作品不存在 - 91视频网站"
          description="抱歉，您访问的影视作品不存在或已被移除，可以返回首页或进入分类页浏览其他内容。"
          keywords="91视频网站,作品不存在,影视资源"
        />
        <div className="w-full px-4 md:px-6 xl:px-10 py-20 text-center">
          <span className="w-16 h-16 mx-auto rounded-full bg-background-100 flex items-center justify-center">
            <i className="ri-file-search-line text-2xl text-foreground-400"></i>
          </span>
          <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950">没有找到这部作品</h1>
          <p className="mt-2 text-sm text-foreground-500">链接可能有误，或者该作品已从站内移除。</p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
            <Link to="/" className="h-10 px-5 inline-flex items-center rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap">
              返回首页
            </Link>
            <Link to="/category/movie" className="h-10 px-5 inline-flex items-center rounded-md border border-background-300 text-foreground-700 text-sm hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap">
              浏览电影频道
            </Link>
          </div>
        </div>
      </SiteLayout>
    );
  }

  return (
    <SiteLayout active={media.type} noFooterTop>
      <Seo
        title={`${media.title} - 91视频网站`}
        description={`${media.title}（${media.year}，${media.region}${typeLabel[media.type]}）：${media.summary.slice(0, 60)}… 导演 ${media.director}，主演 ${media.cast.slice(0, 2).join("、")}。`}
        keywords={`${media.title},91视频网站,${media.genres.join(",")},${media.region}${typeLabel[media.type]},${media.year}${typeLabel[media.type]}`}
      />
      <DetailContent media={media} />
    </SiteLayout>
  );
}